export enum ValidationStatus {
  ERROR_LENGTH = 'error length',
  ERROR_PATTERN = 'error pattern',
  SUCCESS = 'success',
}

export type ValidateNicknameMessage = {
  type: ValidationStatus;
  message: string;
};
